function CapitalizeFilter () {
  function filter (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  }

  return {
    filter
  }
}

export default CapitalizeFilter
